import type { ProductPageVotedWithCommentNotification as ProductPageVotedWithCommentNotificationType } from '@/@types/notification'
import ClickableStackAvatarGroup from '@/components/ClickableStackAvatarGroup'
import { formatAsRelativeTime } from '@/utils/day'
import useNotificationClickHandler from '@/utils/hooks/useNotificationClickHandler'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import ScreenName from '../ScreenName'
import styles from './CommentNotification.module.css'
import NotificationContainer from './NotificationContainer'
import NotificationReference from './NotificationReference'

export interface ProductPageVotedWithCommentNotificationProps extends HTMLAttributes<HTMLDivElement> {
	data: ProductPageVotedWithCommentNotificationType
}

export default function ProductPageVotedWithCommentNotification({
	data,
	className,
	...props
}: ProductPageVotedWithCommentNotificationProps) {
	const {
		actionItem: { users, content, behavior },
		referenceItem,
		createdAt,
	} = data
	const { handleClick, isClickable } = useNotificationClickHandler(data)

	return (
		<NotificationContainer
			onClick={handleClick}
			isClickable={isClickable}
			className={clsx(styles.container, className)}
			{...props}
		>
			<div className={styles.content}>
				<div className={styles.mainRow}>
					<ClickableStackAvatarGroup data={users} />

					<div className={styles.contentColumn}>
						<header className={styles.header}>
							<div className={styles.headerText}>
								<ScreenName data={users[0]} className={styles.screenName} />
								<span className={styles.secondaryText}>{behavior}</span>
							</div>
						</header>

						<main className={styles.main}>
							<div className={styles.contentContainer}>{content}</div>
						</main>
					</div>
				</div>
				<footer className={styles.footer}>
					<span>{formatAsRelativeTime(createdAt)}</span>
				</footer>
			</div>

			<NotificationReference data={referenceItem} />
		</NotificationContainer>
	)
}
